module.exports = __webpack_public_path__ + "static/media/ninx7.6b318095.jpg";